import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { Icons } from '@/font-awesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { vMaska } from "maska"
import { ref, computed, onMounted, onUnmounted, getCurrentInstance, VueElement} from 'vue';

const labelLeft = 20;

export default /*@__PURE__*/_defineComponent({
  __name: 'CommonInput',
  props: {
    prefixIcon: { type: Object, required: false },
    icon: { type: Object, required: false },
    iconButton: { type: Object, required: false },
    modelValue: { type: String, required: true },
    label: { type: String, required: true },
    supportingText: { type: String, required: false },
    state: { type: String, required: false },
    type: { type: String, required: false },
    mask: { type: String, required: false },
    tokenMask: { type: String, required: false },
    isStatic: { type: Boolean, required: false }
  },
  emits: ["update:model-value", "tap-trailing", "leave-focus", "key-down", "on-paste", "change:value"],
  setup(__props: any, { expose: __expose }) {

_useCssVars(_ctx => ({
  "4ccce1c2-inputBackgroundColor": (inputBackgroundColor.value)
}))

const thisInstance = getCurrentInstance();

const inputBefore = ref<HTMLElement | null>(null);
const labelElem = ref<HTMLElement | null>(null);
const currentLabelSize = ref(0);

const props = __props;



__expose({
  setFocus: (v: boolean) => v ? inputField.value?.focus() : inputField.value?.blur(),
});

const state = computed(() => props.state ?? 'default');
const isFocused = ref(false);
const isHovered = ref(false);
const floatOn = computed(() => isFocused.value || props.modelValue.length > 0)
const inputField = ref<HTMLInputElement | null>(null);
const inputBackgroundColor = computed(() => `var(--components-input-${state.value}-background-color, rgba(0, 0, 0, 0.00))`);

const showPassword = ref(false);

function getState() {
  if (state.value == 'error') return state.value;
  if (isFocused.value) {
    return "focused";
  }
  if (isHovered.value && state.value != "disabled") {
    return "hovered";
  }
  return `${state.value}`;
}

function isStatic(){
  if(props.isStatic === undefined || !props.isStatic){
    return false;
  }
  return true;
}
let resizeObserver: ResizeObserver | null = null;
onMounted(() => {
  resizeObserver = new ResizeObserver(() => {
    currentLabelSize.value = labelElem.value?.offsetWidth ?? 0;
  });
  resizeObserver.observe(labelElem.value!);
});

onUnmounted(() => {
  resizeObserver?.disconnect();
});




const __returned__ = { thisInstance, labelLeft, inputBefore, labelElem, currentLabelSize, props, state, isFocused, isHovered, floatOn, inputField, inputBackgroundColor, showPassword, getState, isStatic, get resizeObserver() { return resizeObserver }, set resizeObserver(v) { resizeObserver = v }, get Icons() { return Icons }, get FontAwesomeIcon() { return FontAwesomeIcon }, get vMaska() { return vMaska } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})